import React, { useState } from 'react';
import { Table, Tag, QRCode } from 'antd';

const EquipmentTracking = () => {
  const [equipment] = useState([
    { 
      id: 1,
      name: 'Futbol Topu',
      status: 'active',
      location: 'Ana Depo',
      lastMaintenance: '2024-02-15',
      nextMaintenance: '2024-04-15'
    },
  ]);

  const equipmentColumns = [
    { title: 'Ekipman', dataIndex: 'name', key: 'name' },
    { 
      title: 'Durum', 
      dataIndex: 'status', 
      key: 'status',
      render: status => (
        <Tag color={status === 'active' ? 'success' : 'error'}>
          {status === 'active' ? 'Aktif' : 'Pasif'}
        </Tag>
      )
    },
    { title: 'Konum', dataIndex: 'location', key: 'location' },
    { title: 'Son Bakım', dataIndex: 'lastMaintenance', key: 'lastMaintenance' },
    { title: 'Sonraki Bakım', dataIndex: 'nextMaintenance', key: 'nextMaintenance' },
  ];

  return (
    <div>
      <Table 
        columns={equipmentColumns}
        dataSource={equipment}
        rowKey="id"
        expandable={{
          expandedRowRender: record => (
            <QRCode value={record.id.toString()} />
          )
        }}
      />
    </div>
  );
};

export default EquipmentTracking;